//@flow
import React from 'react';
import classNames from 'classnames';
import './styles.scss';

type Props = {
  title: string,
  onClick: () => void,
  isActive: boolean,
  imageSrc: string,
};

export const NeighbourhoodFilterView = (props: Props) => {
  const { title, onClick, isActive, imageSrc } = props;

  const className = classNames('neighbourhood-filter', {
    highlight: isActive,
  });

  return (
    <div className={className} onClick={onClick}>
      <img src={imageSrc} alt={'filter-icon'} />
      <p>{title}</p>
    </div>
  );
};
